import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    document.addEventListener('turbo:before-stream-render', this._enableInputs.bind(this))
  }

  disableInputs () {
    this._getNodes().forEach(node => {
      node.disabled = true
    })

    document.getElementById('new_folder_button').classList.add('is-hidden')
  }

  _enableInputs () {
    this._getNodes().forEach(node => {
      node.disabled = false
    })

    document.getElementById('new_folder_button').classList.remove('is-hidden')
  }

  haltSubmission () {
    document.getElementById('new_folder').innerHTML = ''
    this._enableInputs()
  }

  _getNodes () {
    return document.querySelectorAll('input, select, textarea')
  }
}
